import VueEcho from 'vue-echo-laravel';
import Vue from "vue";
if (process.env.VUE_APP_SOCKET_URL) {
  window.io = require("socket.io-client");
  Vue.use(VueEcho, {
    broadcaster: 'socket.io',
    client: require('socket.io-client'),
    host: process.env.VUE_APP_SOCKET_URL,
    transports: ['websocket'],
  });
}
